import CreateWorkOrder from "./CreateWorkOrder/CreateWorkOrder";
import WorkOrderInwardList from "./workOrderInwardList";

export { CreateWorkOrder, WorkOrderInwardList }